/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'gatsby';

import BulmaHeading from 'react-bulma-components/lib/components/heading';
import { styledHeadline } from './HeadlineStyles';

const Headline = (blog_headline, uid, extraclass) =>
  blog_headline ? (
    <Link to={`/blog/${uid}`}>
      <BulmaHeading css={styledHeadline} className={extraclass}>
        {blog_headline[0].text}
      </BulmaHeading>
    </Link>
  ) : null;

export default Headline;
